const initialState={
    isLoading:false,
    payment:[]

}
export default initialState;